"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnDeclarationInlineErrorTrackingDataToJSON = exports.ReturnDeclarationInlineErrorTrackingDataFromJSONTyped = exports.ReturnDeclarationInlineErrorTrackingDataFromJSON = void 0;
var runtime_1 = require("../runtime");
function ReturnDeclarationInlineErrorTrackingDataFromJSON(json) {
    return ReturnDeclarationInlineErrorTrackingDataFromJSONTyped(json, false);
}
exports.ReturnDeclarationInlineErrorTrackingDataFromJSON = ReturnDeclarationInlineErrorTrackingDataFromJSON;
function ReturnDeclarationInlineErrorTrackingDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'trackingId': json['trackingId'],
        'error': !(0, runtime_1.exists)(json, 'error') ? undefined : json['error'],
    };
}
exports.ReturnDeclarationInlineErrorTrackingDataFromJSONTyped = ReturnDeclarationInlineErrorTrackingDataFromJSONTyped;
function ReturnDeclarationInlineErrorTrackingDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'trackingId': value.trackingId,
        'error': value.error,
    };
}
exports.ReturnDeclarationInlineErrorTrackingDataToJSON = ReturnDeclarationInlineErrorTrackingDataToJSON;
//# sourceMappingURL=ReturnDeclarationInlineErrorTrackingData.js.map